export default __webpack_public_path__ + "static/1-4-prototypes-0e02bde11c7d07ba5229aacd72a25010.gif";